import { qsa } from "@fluorescent/dom";

const selectors = {
  productSku: "[data-product-sku]",
  productSkuContainer: ".product__vendor_and_sku",
};

const {
  strings: { products: strings },
} = window.theme;

export default function (container, variant) {
  const skuElements = qsa(selectors.productSku, container);
  const skuContainers = qsa(selectors.productSkuContainer, container);

  if (!skuElements.length) return;

  const { sku } = strings.product;
  const skuString = value => `${sku}: ${value}`;

  if (!variant || !variant.sku) {
    skuElements.forEach(skuElement => (skuElement.innerText = ""));
    skuContainers.forEach(skuContainer =>
      skuContainer.setAttribute("data-showing-sku", false)
    );
    return;
  }

  skuElements.forEach(
    skuElement => (skuElement.innerText = skuString(variant.sku))
  );
  skuContainers.forEach(skuContainer =>
    skuContainer.setAttribute("data-showing-sku", true)
  );
}
